import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-generic-alert",
  templateUrl: "generic-alert.component.html",
  standalone: false,
})
export class GenericAlertComponent extends BaseComponent {
  @Input() title: string = "";
  @Input() html: string = "";
  @Input() submitFn: Function;
  @Input() submitText: string = "Submit";
  @Input() closeText: string;
  @Input() prompt: boolean = false;
  @Input() promptPlaceholder: string = this.translate.instant("general.enter_a_value");
  @Input() promptValue: string = "";

  public canSubmitPrompt: boolean = false;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService
  ) {
    super(userService);
    if (!this.closeText) this.closeText = this.translate.instant("general.close");
  }

  onPromptValueChange(value: string) {
    this.promptValue = value || "";
    this.canSubmitPrompt = !!this.promptValue.trim();
  }

  submit() {
    if (this.prompt && !this.canSubmitPrompt) return;
    if (this.submitFn) {
      this.submitFn(this.prompt ? this.promptValue.trim() : this.promptValue);
    }
    this.activeModal.close();
  }
}
